export default __webpack_public_path__ + "static/media/standard_02.63d4a2b0.png";